/**
 * Didomi CMP configuration for OEProfile microsites (profileAnalytics.js constants).
 */
import {
  getDidomiAnalyticsPurposeId,
  getDidomiAnalyticsVendorIds,
  getProfileAnalytics,
  PROFILE_DIDOMI_ANALYTICS_VENDOR_ID,
  PROFILE_DIDOMI_API_KEY,
  PROFILE_DIDOMI_NOTICE_ID,
  PROFILE_DIDOMI_PRIVACY_POLICY_URL,
} from './profileAnalytics';

/**
 * Must be passed on the DidomiSDK `config` prop. @didomi/react does
 * `window.didomiConfig = config`, which wipes any theme set only on window.
 * Include unprefixed selectors too: theme.css is injected into the shadow root,
 * where #didomi-host is the host, not an ancestor of .didomi-notice-banner.
 */
export const DIDOMI_THEME = {
  css: `
    #didomi-host .didomi-notice-banner .didomi-border,
    .didomi-notice-banner .didomi-border {
      border: 1px solid #969696 !important;
      border-radius: 4px !important;
      padding: 10px !important;
    }
  `,
};

export function installDidomiGlobals() {
  if (typeof window === 'undefined') return;
  window.didomiOnReady = window.didomiOnReady || [];
  window.didomiEventListeners = window.didomiEventListeners || [];
  window.didomiConfig = {
    theme: DIDOMI_THEME,
  };
}

installDidomiGlobals();

function readDidomiConfig() {
  return getProfileAnalytics().didomi;
}

export const DIDOMI_API_KEY = PROFILE_DIDOMI_API_KEY;
export const DIDOMI_NOTICE_ID = readDidomiConfig().noticeId || PROFILE_DIDOMI_NOTICE_ID;
export const DIDOMI_ANALYTICS_PURPOSE_ID = getDidomiAnalyticsPurposeId();
export const DIDOMI_ANALYTICS_VENDOR_ID = readDidomiConfig().analyticsVendorId
  || PROFILE_DIDOMI_ANALYTICS_VENDOR_ID;
export const DIDOMI_ANALYTICS_VENDOR_IDS = getDidomiAnalyticsVendorIds();
export const DIDOMI_PRIVACY_POLICY_URL = readDidomiConfig().privacyPolicyUrl
  || PROFILE_DIDOMI_PRIVACY_POLICY_URL;
export const DIDOMI_GDPR_APPLIES_GLOBALLY = readDidomiConfig().gdprAppliesGlobally;
export const DIDOMI_EMBED_TCF_STUB = readDidomiConfig().embedTcfStub;
export const DIDOMI_EMBED_GPP_STUB = readDidomiConfig().embedGppStub;
export const DIDOMI_COUNTRY = readDidomiConfig().country;
export const DIDOMI_REGION = readDidomiConfig().region;

export function getDidomiRuntimeConfig() {
  const { didomi } = getProfileAnalytics();
  return {
    apiKey: PROFILE_DIDOMI_API_KEY,
    noticeId: didomi.noticeId || DIDOMI_NOTICE_ID,
    privacyPolicyUrl: didomi.privacyPolicyUrl || DIDOMI_PRIVACY_POLICY_URL,
    gdprAppliesGlobally: didomi.gdprAppliesGlobally,
    embedTcfStub: didomi.embedTcfStub,
    embedGppStub: didomi.embedGppStub,
    country: didomi.country,
    region: didomi.region,
  };
}
